// domain/kerugian — bagi kerugian part (retur ditolak) ke teknisi vs perusahaan. Murni.
export interface Split { type: 'persen' | 'nominal'; val: number }
export const DEFAULT_SPLIT: Split = { type: 'persen', val: 0 }; // default 0% → perilaku lama (perusahaan tanggung semua sampai O/M set)

/** Porsi rugi yang DITANGGUNG TEKNISI (default). Perusahaan = rugi − ini. Clamp [0, rugi]. */
export function tanggungTeknisi(rugi: number, s: Split): number {
  const r = Math.max(0, rugi);
  const t = s.type === 'nominal' ? (s.val || 0) : r * (s.val || 0) / 100; // settings = jsonb bebas → jaga NaN/undefined
  return Math.min(r, Math.max(0, Math.round(t)));
}

export interface Porsi { ifics: number; tek: number }
/**
 * Bagi porsi untuk bagian rugi yang DIAKUI periode ini, PROPORSIONAL terhadap bucket penuhnya.
 * Perlu karena override & split-nominal adalah nilai TETAP per (teknisi, bulan retur), sedangkan
 * pengakuan di Laba-Rugi disaring per bulan AMBIL → satu bucket bisa terpecah ke beberapa bulan.
 * Tanpa proporsi, nilai tetap itu dikenakan PENUH di tiap potongan (dobel/kurang).
 * Bucket utuh (diakui == penuh) → hasil identik dgn tanpa proporsi (anti-regresi).
 * tek dihitung sebagai sisa → ifics + tek == rugiDiakui persis (tak ada geser pembulatan).
 */
export function porsiProporsional(rugiDiakui: number, rugiPenuh: number, ificsPenuh: number): Porsi {
  const d = Math.max(0, rugiDiakui);
  if (rugiPenuh <= 0 || d <= 0) return { ifics: 0, tek: 0 };
  const ifics = Math.min(d, Math.max(0, Math.round(ificsPenuh * (d / rugiPenuh))));
  return { ifics, tek: d - ifics };
}

/**
 * Apakah suatu kerugian part boleh DIAKUI sebagai pemulihan di periode keuangan ini?
 * Basis = TANGGAL AMBIL (keputusan Apo 18 Jul 2026), supaya pemulihan menempel ke HPP-nya:
 * biaya part masuk HPP saat unit diambil (basis kas), jadi pemulihan harus di bulan yang sama.
 * Bulan retur-ditolak tetap dipakai menu Kerugian Part (dasar potong gaji) — sengaja berbeda.
 * `arsipKeu` (tutup buku) & tiket belum diambil → tidak diakui: HPP-nya tak ada di buku.
 */
export function diakuiDiPeriode(l: { tglAmbilISO: string | null; arsipKeu: boolean }, inPeriode: (iso: string) => boolean): boolean {
  return !l.arsipKeu && !!l.tglAmbilISO && inPeriode(l.tglAmbilISO);
}

/**
 * Porsi rugi yang DITANGGUNG PERUSAHAAN (iFiCs) — inilah yang bisa di-override manual.
 * override diisi → dipakai apa adanya (teknisi = rugi − ini); kosong → default = rugi − tanggungTeknisi.
 * Clamp [0, rugi].
 */
export function tanggungIfics(rugi: number, s: Split, override?: number): number {
  const r = Math.max(0, rugi);
  return Math.min(r, Math.max(0, Math.round(override ?? r - tanggungTeknisi(r, s))));
}
